<template>
  <div>
    <!-- If ByLaw -->
    <div v-if="type === 'by-law'">
      <by-law
        :question-id="questionId"
        :question="question"
        :meeting-options="meetingOptions"
      />
    </div>

    <!-- If Elections -->
    <div v-if="isElectionType" v-cloak>
      <elections-component
        :question-id="questionId"
        :question="question"
        :meeting-options="meetingOptions"
      />
    </div>

    <!-- If Removal of Directors -->
    <div v-if="type === 'director-removals'" v-cloak>
      <director-removals :question-id="questionId" :question="question" />
    </div>
  </div>
</template>

<script>
import ByLaw from '@/components/Questions/Bylaw/Bylaw.vue';
import ElectionsComponent from './Elections/Elections.vue';
import DirectorRemovals from './Removals/Removals';
import _ from 'lodash';
import {mapGetters} from 'vuex';

export default {
  components: {
    ByLaw,
    ElectionsComponent,
    DirectorRemovals
  },
  computed: {
    ...mapGetters('questions', ['questions']),
    ...mapGetters({
      meetingOptions: 'meetingOptions'
    }),
    questionId() {
      return this.$route.params.questionId;
    },
    question() {
      return this.questions[this.questionId];
    },
    type() {
      return _.has(this.question, 'type') ? this.question.type : 'loading';
    },
    optionalVotes() {
      if (_.has(this.question, 'meta.options')) {
        return this.question.meta.options.optionalVotes;
      }
      return 0;
    },
    isElectionType() {
      return _.includes(
        [
          'general-elections',
          'owner-occupied',
          'substitute-elections',
          'substitute-elections-oo',
          'simple-vote'
        ],
        this.type
      );
    }
  }
};
</script>

<style scoped>
.App-done--block__error {
  margin-top: 5rem;
  font-size: 10px;
  opacity: 0.75;
}
</style>
